import { combineReducers } from 'redux';

import AuthenticationReducer from '../../components/authentication/AuthenticationReducer';
import HomePageReducer from '../../components/home-page/home-page-store/HomePageReducer';
import VTOReducer from '../../components/VTO/VTOReducer';

const rootReducer = combineReducers({
    AuthenticationReducer,
    HomePageReducer,
    VTOReducer
});

export default rootReducer;